import type { Moment } from "moment";

export const lastDayOfPeriod = (start: Moment, monthCount: number): Moment => {
  const sameDayLater = start.clone().add(monthCount, "months");
  return sameDayLater.date() < start.date() ? sameDayLater : sameDayLater.subtract(1, "day");
};
